import React from 'react';
import PropTypes from 'prop-types';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as yup from 'yup';
import cx from 'classnames';

import Button from 'common/button';

const AddressFields = ({ onSubmit }) => (
    <Formik
        initialValues={{
            street1: '',
            street2: '',
            city: '',
            stateProv: '',
            zip: '',
        }}
        validationSchema={yup.object().shape({
            street1: yup.string().required('Address is required'),
            street2: yup.string(),
            city: yup.string().required('City is required'),
            stateProv: yup
                .string()
                .required('State is required')
                .length(2, 'Please use 2 letter abbreviation'),
            zip: yup
                .string()
                .required('Zip code is required')
                .min(5, 'Invalid zip code'),
        })}
        onSubmit={onSubmit}
    >
        {({ touched, errors }) => (
            <Form className="mt-4">
                <h3 className="text-lg text-center font-bold leading-normal text-gray-70">
                    Enter Your Address
                </h3>

                <div className="mt-8">
                    <div className="flex flex-wrap -ml-2 -mt-2">
                        <div className="w-full pl-2 pt-2">
                            <Field
                                type="text"
                                name="street1"
                                placeholder="Address 1"
                                className={cx('input-default w-full', {
                                    'is-invalid': touched.street1 && errors.street1,
                                })}
                            />
                            <ErrorMessage
                                component="p"
                                className="text-red mt-2 text-12 text-center"
                                name="street1"
                            />
                        </div>
                        <div className="w-full pl-2 pt-2">
                            <Field
                                type="text"
                                name="street2"
                                placeholder="Address 2"
                                className={cx('input-default w-full', {
                                    'is-invalid': touched.street2 && errors.street2,
                                })}
                            />
                            <ErrorMessage
                                component="p"
                                className="text-red mt-2 text-12 text-center"
                                name="address2"
                            />
                        </div>
                        <div className="w-full pl-2 pt-2">
                            <Field
                                type="text"
                                name="city"
                                placeholder="City"
                                className={cx('input-default w-full', {
                                    'is-invalid': touched.city && errors.city,
                                })}
                            />
                            <ErrorMessage
                                component="p"
                                className="text-red mt-2 text-12 text-center"
                                name="city"
                            />
                        </div>
                        <div className="pl-2 pt-2">
                            <div className="flex flex-wrap -ml-2">
                                <div className="w-1/3 pl-2">
                                    <Field
                                        type="text"
                                        name="stateProv"
                                        placeholder="State"
                                        className={cx('input-default w-full', {
                                            'is-invalid': touched.stateProv && errors.stateProv,
                                        })}
                                    />
                                </div>
                                <div className="w-2/3 pl-2">
                                    <Field
                                        type="text"
                                        name="zip"
                                        placeholder="Zip"
                                        className={cx('input-default w-full', {
                                            'is-invalid': touched.zip && errors.zip,
                                        })}
                                    />
                                </div>
                            </div>
                            <ErrorMessage
                                component="p"
                                className="text-red mt-2 text-12 text-center"
                                name="state"
                            />
                            <ErrorMessage
                                component="p"
                                className="text-red mt-2 text-12 text-center"
                                name="zip"
                            />
                        </div>
                    </div>

                    <div className="mt-8">
                        <Button
                            type="submit"
                            color="green"
                            size="md"
                            data-testid="address-submit"
                            className="block w-full mt-4 text-16 font-medium"
                        >
                            Save information
                        </Button>
                    </div>
                </div>
            </Form>
        )}
    </Formik>
);

AddressFields.propTypes = {
    onSubmit: PropTypes.func.isRequired,
};

export default AddressFields;
